import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { SolicitacaoService } from "app/service/solicitacao/solicitacao.service";
import { MatDialog } from "@angular/material/dialog";
import { DetalhesCaixaComponent } from "app/detalhes-caixa/detalhes-caixa.component";
import { MultiplasOpcoesDialogComponent } from "app/multiplas-opcoes-dialog/multiplas-opcoes-dialog.component";
import { AlocarRecipienteDialogComponent } from "app/alocar-recipiente-dialog/alocar-recipiente-dialog.component";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { AuthenticationService } from "@alfresco/adf-core";
import { CaixaConteudoDTOModel } from "../model/solicitacao/caixaConteudoDTO.model";
import { FormControl } from "@angular/forms";
import { error } from "console";

@Component({
  selector: "app-processar-solicitacao",
  templateUrl: "./processar-solicitacao.component.html",
  styleUrls: ["./processar-solicitacao.component.scss"],
})
export class ProcessarSolicitacaoComponent implements OnInit {
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  IMPLANTACAO = "IMPLANTACAO";
  REQUISICAO = "REQUISICAO";
  REQUISICAOURGENTE = "REQUISICAO_URGENTE";
  DEVOLUCAO = "DEVOLUCAO";
  REALOCACAO = "REALOCACAO_INTERNA";
  REQUISICAOCONTEUDO = "REQUISICAO_CONTEUDO";
  DEVOLUCAOCONTEUDO = "DEVOLUCAO_CONTEUDO";
  MUDARSTATUS = "MUDAR_STATUS";
  dataSolicitacao;
  solicitacaoId;
  solicitacao;
  tpSolicitacao;
  responsavelAbertura;
  cliente;
  area;
  dadosAdicionais;
  caixas = [];
  caixasIncluidas = [];
  implantacaoManual = false;
  rgInclude;
  loading = false;
  resultProcessamento;
  adm = false;
  acervo = false;
  solicitacaoMenu = true;
  conteudosCaixa: CaixaConteudoDTOModel[];
  agrupados: any[] = [];
  showDocumentos = false;
  statusForm = new FormControl;
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private solicitacaoService: SolicitacaoService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {
    this.route.params.subscribe(
      (params) => (this.solicitacaoId = params["id"])
    );

    //console.log(this.solicitacaoId)
  }

  ngOnInit() {
    this.getSolicitacao(this.solicitacaoId);
  }

  listarConteudoSolicitacao(solicitacaoId: number) {
    this.solicitacaoService.buscarConteudoSolicitacao(solicitacaoId).subscribe(
      (data) => {
        console.log(data);
        if (data.success) {
          this.conteudosCaixa = data.result;
          this.formatarRetorno(this.conteudosCaixa);
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  formatarRetorno(dados: any[]) {
    const agrupados: { [key: string]: any } = {};
    dados.forEach((item) => {
      const rgCaixa = item.rgCaixa;
      if (!agrupados[rgCaixa]) {
        agrupados[rgCaixa] = {
          rgCaixa: rgCaixa,
          conteudos: [],
        };
      }
      const conteudo = {
        descConteudo: item.descConteudo,
        codConteudo: item.codConteudo,
        tipoConteudo: item.tipoConteudo,
      };
      agrupados[rgCaixa].conteudos.push(conteudo);
    });

    const resultado = Object.keys(agrupados).map((key) => agrupados[key]);
    // const resultadoJSON = JSON.stringify(resultado);
    console.log(resultado);
    this.agrupados = resultado;
  }

  getSolicitacao(solicitacaoId) {
    this.solicitacaoService.getSolicitacao(solicitacaoId).subscribe(
      (data) => {
        console.log(data);
        this.solicitacao = data;
        this.tpSolicitacao = this.solicitacao.tipoDaSolicitacao;
        this.dataSolicitacao = this.solicitacao.dataAbertura;
        this.cliente = this.solicitacao.cliente.nome;
        this.area = this.solicitacao.area.descricao;
        this.dadosAdicionais = this.solicitacao.dadosAdicionais;
        this.caixas = this.solicitacao.caixas;
        this.responsavelAbertura = this.solicitacao.responsavelAbertura;

        if (this.tpSolicitacao === "REQUISICAO_CONTEUDO") {
          this.listarConteudoSolicitacao(solicitacaoId);
          this.showDocumentos = true;
        }
        if (this.tpSolicitacao === "DEVOLUCAO_CONTEUDO") {
          this.listarConteudoSolicitacao(solicitacaoId);
          this.showDocumentos = true;
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  converteTipo(tipo) {
    if (tipo == "IMPLANTACAO") {
      return "IMPLANTACÃO";
    } else if (tipo == "REQUISICAO") {
      return "REQUISIÇÃO";
    } else if (tipo == "DEVOLUCAO") {
      return "DEVOLUÇÃO";
    } else if (tipo == "REALOCACAO_INTERNA") {
      return "REALOCAÇÃO INTERNA";
    } else {
      return tipo;
    }
  }

  isDevolucao() {
    if (this.tpSolicitacao == this.DEVOLUCAO) {
      return true;
    }
  }

  isRequisicao() {
    if (
      this.tpSolicitacao === this.REQUISICAO ||
      this.tpSolicitacao === this.REQUISICAOURGENTE
    ) {
      return true;
    }
  }

  isRequisicaoConteudo() {
    if (this.tpSolicitacao === this.REQUISICAOCONTEUDO) {
      return true;
    }
  }

  isDevolucaoConteudo() {
    if (this.tpSolicitacao === this.DEVOLUCAOCONTEUDO) {
      return true;
    }
  }

  isImplantacao() {
    if (this.tpSolicitacao == this.IMPLANTACAO) {
      return true;
    }
  }

  isMudarStatus() {
    if (this.tpSolicitacao == this.MUDARSTATUS) {
      return true;
    }
  }

  isRealocacao() {
    if (this.tpSolicitacao == this.REALOCACAO) {
      return true;
    }
  }

  detalhesCaixa(caixa) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth - innerWidth / 2 + "px";
    }
    const dialogRef = this.dialog.open(DetalhesCaixaComponent, {
      data: { dataDialog: caixa },
      width: largura,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  escolherProcessamento() {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth - innerWidth / 1.3 + "px";
    }
    const dialogRef = this.dialog.open(MultiplasOpcoesDialogComponent, {
      width: largura,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == "MANUAL") {
        this.alterarImplantacaoManual();
      } else if (result == "AUTOMATICO") {
        this.openSnackBarSuccess("Alocando recipientes ! ");
        this.loading = true;
        let user = localStorage.getItem("APS_USERNAME");
        let body = { solicitacaoId: this.solicitacao.id, username: user };
        this.solicitacaoService
          .processarSolicitacaoAutomatica(body)
          .subscribe((data) => {
            this.resultProcessamento = data;
            if (this.resultProcessamento.cod == 200) {
              this.openSnackBarSuccess("Solicitação finalizada com sucesso !");
              this.router.navigate(["solicitacoes"]);
            } else if (this.resultProcessamento.cod == 300) {
              this.loading = false;
              this.openSnackBarError(this.resultProcessamento.message);
            } else {
              this.loading = false;
              this.openSnackBarError(this.resultProcessamento.message);
            }
          });
      } else {
        this.openSnackBarError("Tipo de processamento não selecionado ! ");
      }
    });
  }

  alterarImplantacaoManual() {
    this.implantacaoManual = true;
  }

  alocarRecipiente() {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth - innerWidth / 2 + "px";
    }
    const dialogRef = this.dialog.open(AlocarRecipienteDialogComponent, {
      data: { solicitacao: this.solicitacao },
      width: largura,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  RealocarRecipiente() {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth - innerWidth / 2 + "px";
    }
    const dialogRef = this.dialog.open(AlocarRecipienteDialogComponent, {
      data: { solicitacao: this.solicitacao, realocacao: true },
      width: largura,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  incluirCaixa() {
    console.log(this.rgInclude);
    let caixaSelected = null;
    this.caixas.forEach((element) => {
      if (element.rgCaixa == this.rgInclude) {
        caixaSelected = element;
      }
    });
    if (caixaSelected != null) {
      this.caixasIncluidas.push(caixaSelected);
      this.openSnackBarSuccess("Caixa incluída com sucesso !");
    } else {
      this.openSnackBarError("Caixa não encontrada nesta solicitação !");
    }

    this.rgInclude = "";
  }

  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }

  finalizarImplantacao() {
    this.loading = true;
    let user = localStorage.getItem("APS_USERNAME");
    let body = { solicitacaoId: this.solicitacao.id, username: user };
    this.solicitacaoService
      .finalizarSolicitacaoManual(body)
      .subscribe((data) => {
        this.resultProcessamento = data;
        if (this.resultProcessamento.cod == 200) {
          this.openSnackBarSuccess("Solicitação finalizada com sucesso !");
          this.router.navigate(["solicitacoes"]);
        } else {
          this.loading = false;
          this.openSnackBarError(this.resultProcessamento.message);
        }
      });
  }

  processarRequisicao() {
    this.loading = false;
    let user = localStorage.getItem("APS_USERNAME");
    let body = { solicitacaoId: this.solicitacao.id, username: user };
    this.solicitacaoService.processarRequisicao(body).subscribe((data) => {
      this.resultProcessamento = data;
      if (this.resultProcessamento.cod == 200) {
        this.openSnackBarSuccess("Solicitação processada com sucesso !");
        this.router.navigate(["solicitacoes"]);
      } else {
        this.loading = false;
        this.openSnackBarError(this.resultProcessamento.message);
      }
    });
  }

  processarRequisicaoConteudo() {
    this.loading = false;
    this.solicitacaoService
      .processarSolicitacaoConteudo(this.solicitacaoId)
      .subscribe(
        (data) => {
          console.log(data);
          if (data.success) {
            this.openSnackBarSuccess("Solicitação processada com sucesso !");
            this.router.navigate(["solicitacoes"]);
          } else {
            this.loading = false;
            this.openSnackBarError(data.message);
          }
        },
        (err) => {
          console.error(err);
        }
      );
  }

  processarDevolucaoConteudo() {
    this.loading = false;
    this.solicitacaoService
      .processarSolicitacaoDevolucaoConteudo(this.solicitacaoId)
      .subscribe(
        (data) => {
          console.log(data);
          if (data.success) {
            this.openSnackBarSuccess("Solicitação processada com sucesso !");
            this.router.navigate(["solicitacoes"]);
          } else {
            this.loading = false;
            this.openSnackBarError(data.message);
          }
        },
        (err) => {
          console.error(err);
        }
      );
  }

  verificarCaixasIncluidas(rgCaixa) {
    let incluida = false;
    this.caixasIncluidas.forEach((element) => {
      if (rgCaixa == element.rgCaixa) {
        incluida = true;
      }
    });

    return incluida;
  }

  processarDevolucao() {
    this.loading = false;
    let user = localStorage.getItem("APS_USERNAME");
    let body = { solicitacaoId: this.solicitacao.id, username: user };
    this.solicitacaoService.processarDevolucao(body).subscribe((data) => {
      this.resultProcessamento = data;
      if (this.resultProcessamento.cod == 200) {
        this.openSnackBarSuccess("Solicitação processada com sucesso !");
        this.router.navigate(["solicitacoes"]);
      } else {
        this.loading = false;
        this.openSnackBarError(this.resultProcessamento.message);
      }
    });
  }

  processarRealocacao() {
    this.loading = true;
    let user = localStorage.getItem("APS_USERNAME");
    let body = { solicitacaoId: this.solicitacao.id, username: user };
    this.solicitacaoService.finalizarRealocacao(body).subscribe((data) => {
      this.resultProcessamento = data;
      if (this.resultProcessamento.cod == 200) {
        this.openSnackBarSuccess("Solicitação finalizada com sucesso !");
        this.router.navigate(["solicitacoes"]);
      } else {
        this.loading = false;
        this.openSnackBarError(this.resultProcessamento.message);
      }
    });
  }

  voltar() {
    this.router.navigate(["solicitacoes"]);
  }

  processarSolicitacaoMudarStatus() {
    if (this.statusForm.value !== null) {
      this.solicitacaoService.processarSolicitacaoMudarStatus(this.solicitacaoId, this.statusForm.value)
      .subscribe(data => {
        console.log(data);
        this.openSnackBarSuccess("Solicitação processada com sucesso.");
        this.router.navigate(["solicitacoes"]);
      }, 
      error=> {
        console.error(error);
        this.openSnackBarError('Erro ao tentar processar solicitação.');
      });
    } else {
      this.openSnackBarError('Selecione um status para a solicitação.');
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/processar-solicitacao/processar-solicitacao.component.ts